<template>
    <li class="nav-item" :class="{ show: isOpen }">
        <slot/>
    </li>
</template>
<script>
export default {
    name: 'AppNavItem',
    provide() {
        return { navItem: this }
    },
    data() {
        return {
            isOpen: false
        }
    },
    watch: {
        $route() {
            this.isOpen = false
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen
        },
        close() {
            this.isOpen = false
        },
        handleOutsideClick(event) {
            if (!this.$el.contains(event.target)) {
                this.isOpen = false
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick)
    }
}
</script>
